import NUS_LOGO from '../img/logos/nus_logo.jpg';
import SAJC_LOGO from '../img/logos/SAJC_LOGO.png';
import KTH_LOGO from '../img/logos/KTH_Royal_Institute_of_Technology_logo.png';

/**
 * Latest experience at the front of the array
 */
const schExperience = [
  {
    year: 'Aug 2021 - Aug 2025',
    logo: NUS_LOGO,
    title:
      'Bachelor of Engineering (Honours) in Biomedical engineering, 2nd Major in Computer Science',
    subTitle: 'National University of Singapore',
    text: `Studying Biomedical Engineering at the National University of Singapore, focusing in the area of Robotics with 
    a second major in Computer Science. I am currently Graduating in Aug 2025.`,
  },
  {
    year: 'Jan 2024 - May 2024',
    logo: KTH_LOGO,
    title: 'Exchange Programme',
    subTitle: 'KTH Royal Institute of Technology',
    text: 'I went on exchange at the KTH Royal Institute of Technology in Sweden (Y3S2). I took courses in Biomedical Engineering and Computer Science.',
  },
  {
    year: 'Feb 2021 - May 2021',
    logo: NUS_LOGO,
    title: 'iBlocs for CS1010X',
    subTitle: 'National University of Singapore',
    text: 'I was a student under the iBlocs programme for CS1010X Programming Methodology.',
  },
  {
    year: 'Jan 2017 - Dec 2019',
    logo: SAJC_LOGO,
    title: 'Science Course',
    subTitle: "St Andrew's Junior College",
    text: "I studied Science at St Andrew's Junior College. I took the A Level H2 Mathematics, H2 Physics, H2 Chemistry, H1 Economics, H1 General Paper, H1 Mother Tongue (Chinese) and H1 Project work.",
  },
];

export default schExperience;
